import { c as _c } from "react-compiler-runtime";
import { Loader2 } from "lucide-react";
export function PhotoPendingState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-white/10 text-white/70"><Loader2 className="h-5 w-5 animate-spin" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}